import DefaultResetForm from '@/components/DefaultResetForm';
import { CustomTextField } from '@/components/Formik/CustomTextField';
import { useUser } from '@/contexts/AuthContext';
import { api } from '@/services/apiClient';
import { resetSocialMedia } from '@/validators/resetUsersInfo';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FormikValues } from 'formik';
import { IModalSuccessData } from '.';

interface ResetSocialMedias {
  onSuccess: (value: IModalSuccessData) => void;
  handleClose: () => void;
}

const ResetSocialMedias = ({ onSuccess, handleClose }: ResetSocialMedias) => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const { user, updateUserData } = useUser();

  const handleSubmitResetSocialMediasForm = async (values: FormikValues) => {
    const userUpdate = {
      cpf: user?.cpf,
      username: user?.username,
      name: user?.name,
      email: user?.email,
      ...values,
    };

    await api.put('/auth/users/me/', userUpdate);

    onSuccess({
      isOpen: true,
      text: 'Suas redes socias foram alteradas com sucesso!',
    });
    updateUserData(userUpdate);
  };
  return (
    <DefaultResetForm
      title=""
      buttonText="Salvar"
      onSubmit={handleSubmitResetSocialMediasForm}
      handleClose={handleClose}
      handleCancel={handleClose}
      initialValues={{
        facebook_url: user?.facebook_url,
        instagram_url: user?.instagram_url,
        linkedin_url: user?.linkedin_url,
      }}
      validationSchema={resetSocialMedia}
    >
      {!smUp && (
        <Typography component="h3" variant="h6">
          Editar
        </Typography>
      )}
      <Box sx={{ display: 'grid', gap: '16px' }}>
        <CustomTextField
          label="Facebook"
          placeholder="https://www.facebook.com"
          name="facebook_url"
          variant="standard"
        />
        <CustomTextField
          label="Instagram"
          placeholder="https://www.instagram.com"
          name="instagram_url"
          variant="standard"
        />
        <CustomTextField
          label="Linkedin"
          placeholder="https://www.linkedin.com"
          name="linkedin_url"
          variant="standard"
        />
      </Box>
    </DefaultResetForm>
  );
};

export default ResetSocialMedias;
